import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginForm } from "@marekl/adminer/components";
import type { User } from "../../auth/queries";
import { getSafeReturnTo } from "../../auth/returnTo";
import {
  LettermanEnvelope,
  LettermanEnvelopeFooter,
} from "../../shell/LettermanBrand";
import styles from "./LoginPage.module.css";

/**
 * The sign-in card is addressed like an envelope: the return address and the
 * franked stamp up top (the form's `brand` slot), "Deliver to · Sign in" over
 * the fields, and the build's barcode along the bottom edge (`footer`).
 */
export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = getSafeReturnTo(searchParams.get("returnTo"));

  return (
    <LoginForm<User>
      className="lm-login"
      brand={<LettermanEnvelope />}
      subtitle={
        <span className={styles.deliverTo}>
          <span className={styles.deliverToKey}>Deliver to</span>
          <span className={styles.deliverToTitle}>Sign in</span>
        </span>
      }
      footer={<LettermanEnvelopeFooter />}
      onSuccess={() => navigate(returnTo, { replace: true })}
    />
  );
}
